module.exports = __webpack_public_path__ + "static/media/Surrounding5.de66fed4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding5.jpeg
// module id = 578
// module chunks = 0